import { Injectable } from "@angular/core";
import jwt_decode from "jwt-decode";

@Injectable({ providedIn: 'root' })

export class TokenService {

    constructor() {

    }

    public GetTokenInfo(key) {
        var token = sessionStorage.getItem("tokenInfo");
        var decoded = jwt_decode(token);
        var val = "";
        if (key) {
            return decoded[key];
        }
        return decoded;
    }


}